import React, { ReactElement, useEffect, useState } from 'react';
import { IStream } from "@common/redux/types/invoices";
import styles from './StreamsHeader.module.scss';
import { ClockIcon } from "@kursk/components/ui/icons";
import moment from "moment";
import { videoSrcBuildersHash } from "@common/utils/video";
import { getImageUrl } from "@common/utils/image";
import classNames from "classnames";
import { BannerImage } from '@kursk/components/ui/BannerImage/BannerImage';
import { AuthorInfo } from "@kursk/components/ui/AuthorInfo/AuthorInfo";
import { PublicFavoritesButton } from "@kursk/components/ui/FavoritesButton/PublicFavoritesButton";
import { ENABLED_FAVORITES_ENTITY_TYPES, FavoritesTypesEnum } from "@common/redux/types/favorites";
import { getConfig } from "@root/config/config";

const config = getConfig();

const isFavoriteFeatureEnabled = config.features.favorites.enabled &&
  ENABLED_FAVORITES_ENTITY_TYPES.includes(FavoritesTypesEnum.Streams);

interface IProps {
  entity: IStream;
}

export function StreamsHeader({ entity }: IProps): ReactElement {
  const [videoSrc, setVideoSrc] = useState(null);
  const [videoPlay, setVideoPlay] = useState(false);
  const isStart = entity.start < +new Date();

  useEffect(() => {
    const fetchSrc = async () => {
      const response = await videoSrcBuildersHash[entity?.source?.provider](entity?.source?.id);
      setVideoSrc(response);
    };
    if (entity?.source?.id && entity?.source?.provider) {
      fetchSrc();
    }
  }, []);
  const playHandler = () => {
    setVideoPlay(true);
  }

  const typeAndDurationComponents = (
    <>
      <span className={styles.type}>Трансляция</span>
      <span className={styles.duration}>
        <ClockIcon/>
        {entity.duration} мин
      </span>
    </>
  )

  return (
    <div className={styles.streams_wrapper}>
      <div className={styles.header_wrapper}>
        {isStart && <div className={styles.streams_video}>
          <div className={classNames(videoPlay ? styles.streams_video__hide : styles.streams_video__overlay)}
            onClick={playHandler}>
            <div className={styles.streams_video__play}>
              <div className={styles.streams_video__triangle}>
              </div>
            </div>
          </div>
          <img className={classNames(videoPlay && styles.streams_video__hide)}
            src={getImageUrl(entity?.cover)} alt={entity?.cover?.realName}/>
          {videoSrc &&
          <iframe
            allowFullScreen
            className={styles.video}
            frameBorder="0"
            src={videoSrc}
            title="video"
          />
          }
        </div>}
        {!isStart &&
        <div className={styles.streams_cover}>
          <BannerImage
            desktopImage={entity?.cover}
            tabletImage={entity?.cover}
            mobileImage={entity?.cover}
          />
          <AuthorInfo image={entity.cover}/>
        </div>}
      </div>
      <div className={styles.streams_title}>
        <div className={styles.streams_type}>
          {isFavoriteFeatureEnabled ? (
            <div className={styles.favoriteContainer}>
              <div className={styles.typeAndDurationContainer}>
                {typeAndDurationComponents}
              </div>
              <PublicFavoritesButton
                key={entity._id}
                entityId={`${entity._id}`}
                entityType={FavoritesTypesEnum.Streams}
                entity={entity}
              />
            </div>
          ) : <>{typeAndDurationComponents}</>}
        </div>
        <h1 className={styles.streams_name}>
          {entity.name}
        </h1>
        <div className={styles.streams_date}>
          {moment(entity.start).format('D MMMM YYYY, H:mm')}
        </div>
      </div>
    </div>
  );
}
